// real stories slider
$('.real-stories-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: false,
  prevArrow: $('.stories-prev'),
  nextArrow: $('.stories-next'),

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.reason-section-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: false,
  prevArrow: $('.reason-prev'),
  nextArrow: $('.reason-next'),

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});

$('.rp-grid-slider').slick({
  slidesToShow: 6,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: false,
  prevArrow: $('.people-prev'),
  nextArrow: $('.people-next'),

  responsive: [
    {
      breakpoint: 1560,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.2
      }
    }
  ]
});

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.rp-play');
  if (!btn) return;

  const wrapper = btn.closest('.rp-video');
  const video = wrapper.querySelector('video');

  video.play().then(() => {
    btn.classList.add('hidden'); // hide play button
    wrapper.classList.add('playing');
  }).catch(err => {
    console.log('Video play blocked:', err);
  });
});


// "Trusted by thousands" strip. Native overflow scroll with snap, so it swipes on
// touch and keeps momentum for free. The arrows just nudge the same scroller, which
// replaced the old transform carousel that only ever responded to arrow clicks.
document.querySelectorAll('.pdp-testimonials').forEach(function (section) {
  var viewport = section.querySelector('.pdp-strip-viewport');
  var track = section.querySelector('.pdp-video-slider');
  if (!viewport || !track) return;
  track.style.transform = '';
  var prev = section.querySelector('.pdp-prev');
  var next = section.querySelector('.pdp-next');
  function step() {
    var card = track.querySelector('.rp-card');
    return card ? card.getBoundingClientRect().width + 12 : viewport.clientWidth * 0.8;
  }
  if (prev) prev.addEventListener('click', function () { viewport.scrollBy({ left: -step(), behavior: 'smooth' }); });
  if (next) next.addEventListener('click', function () { viewport.scrollBy({ left: step(), behavior: 'smooth' }); });
});

// "Trusted by thousands" now lives at the very bottom of the product info column,
// under the "Why Trust Corewella as your Wellness Partner" block, on every screen
// size (27 Aug 2026). It used to sit under the gallery on desktop and above the
// Description on mobile; the client asked for one consistent position.
//
// Runs on a loop, not once: the bundle preselect fires a variant change on load,
// the Section Rendering API replaces .product__blocks wholesale, and a one-shot
// move was silently undone by that re-render (measured on live, 27 Aug 2026).
(function () {
  function place() {
    var strip = document.querySelector('.pdp-testimonials');
    if (!strip) return;
    var blocks = document.querySelector('.product__info-wrapper .product__blocks');
    if (!blocks) return;
    var anchor = blocks.querySelector('.trust-block') || blocks.lastElementChild;
    if (!anchor || anchor === strip) return;
    if (strip.previousElementSibling === anchor) return;
    anchor.insertAdjacentElement('afterend', strip);
  }
  place();
  window.addEventListener('load', function () { setTimeout(place, 400); });
  var host = document.querySelector('.product__info-wrapper') || document.body;
  new MutationObserver(place).observe(host, { childList: true, subtree: true });
})();

// Preselect the middle bundle (Buy 2 Get 1 Free, the "Most Popular" card) on a
// fresh product view. Shopify defaults to the first variant, which is Buy 3, and
// the cards are ordered cheapest-first visually, so without this the highlighted
// card and the selected variant disagree. Skipped when the URL already names a
// variant, so shared and back-button links keep their choice.
// Runs on window load, not at parse time: the theme's variant-picker binds its
// listeners later, so a change event dispatched during parse went nowhere and the
// Add To Cart button kept the server-rendered Buy 3 price while the Buy 2 card
// showed as selected (measured on live, 13 Aug 2026). click() rather than setting
// .checked so the theme sees exactly what a real click looks like.
window.addEventListener('load', function () {
  if (new URL(window.location.href).searchParams.get('variant')) return;
  var popular = document.querySelector('.corewella-bundle-card--popular');
  if (!popular) return;
  var input = document.getElementById(popular.getAttribute('for'));
  if (!input || input.disabled) return;
  setTimeout(function () { input.click(); }, 120);
});

// Judge.me pagination. The shop is on Judge.me's v3 widget, but sections/review.liquid
// renders the product's legacy widget metafield, and the v3 bundle only wires widgets
// that carry data-entry-point (their loader bails out early when it finds none). So the
// server-rendered paginator sat there dead: a shopper saw 5 of 10,080 reviews and
// clicking page 2 did not even fire a request (measured on live, 10 Sep 2026). Their
// public widget endpoint is the one the legacy widget itself called, and it returns the
// next page of reviews AND its own paginator, so there is nothing to rebuild by hand.
// Bails out the moment the widget gains data-entry-point, so installing Judge.me's own
// app block later takes over cleanly instead of double-handling the click.
(function () {
  var widget = document.querySelector('.cw-jdgm .jdgm-widget');
  if (!widget || widget.hasAttribute('data-entry-point')) return;

  var productId = widget.getAttribute('data-id');
  var shop = window.Shopify && window.Shopify.shop;
  if (!productId || !shop) return;

  var busy = false;

  function go(page) {
    var list = widget.querySelector('.jdgm-rev-widg__reviews');
    var pag = widget.querySelector('.jdgm-paginate');
    if (busy || !list || !pag || !(page > 0)) return;
    busy = true;

    var perPage = parseInt(pag.getAttribute('data-per-page'), 10) || 5;
    var url = 'https://api.judge.me/reviews/reviews_for_widget?legacy_widget=true&platform=shopify' +
      '&shop_domain=' + encodeURIComponent(shop) +
      '&product_id=' + encodeURIComponent(productId) +
      '&page=' + page + '&per_page=' + perPage;

    fetch(url)
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        if (!data || !data.html) return;
        // Keep the paginator under the reader's finger. The new page can be taller or
        // shorter than the old one, and a page that jumps is the whole complaint.
        var before = pag.getBoundingClientRect().top;
        pag.remove();
        list.outerHTML = data.html;
        // Judge.me ships each review half-built: the avatar holds a raw initial and
        // the timestamp is an empty <time> waiting on data-content. Their own script
        // finishes both, and it is what already ran over the first page, so the swapped
        // page has to be handed to it or the letters show up above the names.
        try { window.jdgm.customizeReviews(); } catch (e) {}
        var moved = widget.querySelector('.jdgm-paginate');
        if (moved) window.scrollBy(0, moved.getBoundingClientRect().top - before);
      })
      .catch(function () { /* leave the page alone; the reviews on screen still read */ })
      .then(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.cw-jdgm .jdgm-paginate__page');
    if (!a) return;
    e.preventDefault();
    go(parseInt(a.getAttribute('data-page'), 10));
  });
})();

// The "(N reviews)" link in the PDP social-proof bar points at #reviews. The anchor
// alone works, but instantly teleporting past a 12,000px page reads as a glitch, so
// take the same jump smoothly. CSS cannot scope scroll-behavior to one link, and
// setting it on <html> would change every anchor on the site.
document.addEventListener('click', function (e) {
  var link = e.target.closest && e.target.closest('a[href="#reviews"]');
  var target = link && document.getElementById('reviews');
  if (!target) return;
  e.preventDefault();
  target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  // The jump is ~10,000px and every image it passes is lazy, so they load mid-scroll
  // and drag the section down behind us (measured: 535px short of where it aimed).
  // Correct once after the page settles rather than chasing it.
  setTimeout(function () {
    if (target.getBoundingClientRect().top > 200) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, 800);
});

// Customer videos (the "Trusted by thousands" strip and the Real People section)
// used to autoplay on load, so all six files (~2.7 MB) downloaded before anyone had
// scrolled near them (measured 10 Sep 2026). They now start once their strip is
// within 400px of the screen, the whole strip at once, so cards still off to the
// right in the horizontal scroller are already playing when swiped in.
// ponytail: a 500ms poll instead of an IntersectionObserver on fixed nodes. The product
// section re-renders on variant change and hands us fresh videos an observer would never
// see, and once every video has started the query matches nothing.
(function () {
  function check() {
    document.querySelectorAll('video[data-lazy-video=""]').forEach(function (v) {
      var strip = v.closest('.pdp-video-slider, .rp-grid') || v;
      var r = strip.getBoundingClientRect();
      if (r.bottom < -400 || r.top > window.innerHeight + 400) return;
      v.setAttribute('data-lazy-video', 'on');
      v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }
  check();
  setInterval(check, 500);
})();
